import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { Controller } from 'react-hook-form';

import type { FormFieldProps } from './types';

const FormFieldMultiSelect = ({ placeholder, name, options, error, label, control, required }: FormFieldProps) => {
    const setLabel = required ? (
        <div className='InputText__madatoryLabel'>
            <OverlayTrigger
                placement='top-start'
                overlay={
                    <Tooltip>
                        <p>Mandatory field</p>
                    </Tooltip>
                }
            >
                <label className='InputText__label' htmlFor={name}>
                    {label}
                </label>
            </OverlayTrigger>
            <span className='InputText__mandatoryIcon'>*</span>
        </div>
    ) : (
        <label className='InputText__label' htmlFor={name}>
            {label}
        </label>
    );

    return (
        <div className={`form-group mb-0 ${error && 'has-error has-feedback'}`}>
            {setLabel}
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <Multiselect
                        id={name}
                        placeholder={placeholder}
                        options={options}
                        value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : []}
                        noItemMessage='No items are available'
                        multiline
                        onChange={item => {
                            field.onChange(item);
                        }}
                    />
                )}
            />
            {error && (
                <>
                    <span className='form-control-feedback rioglyph rioglyph-error-sign top-27' />
                    <span className='help-block'>
                        <span>{error.message}</span>
                    </span>
                </>
            )}
        </div>
    );
};
export default FormFieldMultiSelect;
